import script from "./CreateUpdateSafetyStockRule.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateUpdateSafetyStockRule.vue?vue&type=script&setup=true&lang=ts"

import "./CreateUpdateSafetyStockRule.vue?vue&type=style&index=0&id=60e7e942&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60e7e942"]])

export default __exports__